jQuery(function($) {

  applyHoverStates();

  if($('#df-target').length > 0) {
    var controller = new ScrollMagic.Controller();

    var scene1 = new ScrollMagic.Scene({
      triggerElement: "#df-trigger2"
    });

    var scene2 = new ScrollMagic.Scene({
      triggerElement: "#df-trigger2"
    });

    var scene3 = new ScrollMagic.Scene({
      triggerElement: "#df-trigger2", duration: 300
    });

    var scene4 = new ScrollMagic.Scene({
      triggerElement: "#df-trigger1", duration: 300
    });

    var scene5 = new ScrollMagic.Scene({
      triggerElement: "#df-trigger2", duration: 300
    });

    var tweenBigCirclesTop = TweenMax.to(".df__circles__circle--top", .25, {opacity:0})
    var tweenCenter = TweenMax.to(".df__circles__center", .25, {opacity:0})
    var tweenBigCirclesBottom = TweenMax.to(".df__circles__circle--bottom", .25, {opacity:0})

    var tweenGrid = TweenMax.from(".df__grid", .25, {opacity:0})
    var tweenGridLegend = TweenMax.from(".df__grid__legend", .25, {opacity:0})

    // setOrbit(controller);

    scene1.setTween(tweenBigCirclesTop);
    // scene1.addIndicators({name: "1 (duration: 300)"});
    scene1.addTo(controller);

    scene2.setTween(tweenCenter);
    scene2.addTo(controller);

    scene3.setTween(tweenBigCirclesBottom);
    scene3.addTo(controller);

    scene4.setTween(tweenGrid);
    scene4.addTo(controller);

    scene5.setTween(tweenGridLegend);
    scene5.addTo(controller);
  }

  function setOrbit(controller) {
    var scene1 = new ScrollMagic.Scene({
      triggerElement: "#df-trigger1"
    });
    var scene2 = new ScrollMagic.Scene({
      triggerElement: "#df-trigger1"
    });
    var scene3 = new ScrollMagic.Scene({
      triggerElement: "#df-trigger1"
    });
    var scene4 = new ScrollMagic.Scene({
      triggerElement: "#df-trigger1"
    });

    var path = [{x:0, y:0}, {x:25, y:-25}, {x:25, y:-25}];
    var tweenOrbit1 = TweenMax.to("#bcircle1", 2, {bezier:{curviness: 0.3, values:path}, ease:Power1.easeInOut})

    var path = [{x:0, y:0}, {x:-25, y:-25}, {x:-25, y:-25}];
    var tweenOrbit2 = TweenMax.to("#mcircle2", 2, {bezier:{curviness: 0.3, values:path}, ease:Power1.easeInOut})

    var path = [{x:0, y:0}, {x:25, y:25}, {x:25, y:25}];
    var tweenOrbit3 = TweenMax.to("#mcircle1", 2, {bezier:{curviness: 0.3, values:path}, ease:Power1.easeInOut})

    var path = [{x:0, y:0}, {x:-25, y:25}, {x:-25, y:25}];
    var tweenOrbit4 = TweenMax.to("#bcircle2", 2, {bezier:{curviness: 0.3, values:path}, ease:Power1.easeInOut})

    scene1.setTween(tweenOrbit1);
    // scene1.setPin("#bcircle1", {pushFollowers: false});
    scene1.addTo(controller);

    scene2.setTween(tweenOrbit2);
    // scene2.setPin("#mcircle1", {pushFollowers: false});
    scene2.addTo(controller);

    scene3.setTween(tweenOrbit3);
    // scene3.setPin("#mcircle2", {pushFollowers: false});
    scene3.addTo(controller);

    scene4.setTween(tweenOrbit4);
    // scene4.setPin("#bcircle2", {pushFollowers: false});
    scene4.addTo(controller);
  }

  function applyHoverStates() {

    $('body').on('click', function() {
      $("svg").find(".tooltip").css('opacity', '0');
    });

    applyPlanningHoverStates();
    applyNeedsHoverStates();
    applyContImprovHoverStates();
    applyProgrammingHoverStates();

  }

  function applyPlanningHoverStates() {

    $("svg").find("#expertise .planning-cls3").on('mouseover', function(){
      $("svg").find(".expertise-tooltip").css('opacity', '1');
    });

    $("svg").find("#expertise .planning-cls3").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".expertise-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#expertise .planning-cls3").on('mouseout', function(){
      $("svg").find(".expertise-tooltip").css('opacity', '0');
    });

    $("svg").find("#expertise image").on('mouseover', function(){
      $("svg").find(".expertise-tooltip").css('opacity', '1');
    });

    $("svg").find("#expertise image").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".expertise-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#expertise image").on('mouseout', function(){
      $("svg").find(".expertise-tooltip").css('opacity', '0');
    });

    $("svg").find("#vision .planning-cls3").on('mouseover', function(){
      $("svg").find(".vision-tooltip").css('opacity', '1');
    });

    $("svg").find("#vision .planning-cls3").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".vision-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#vision .planning-cls3").on('mouseout', function(){
      $("svg").find(".vision-tooltip").css('opacity', '0');
    });

    $("svg").find("#vision image").on('mouseover', function(){
      $("svg").find(".vision-tooltip").css('opacity', '1');
    });

    $("svg").find("#vision image").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".vision-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#vision image").on('mouseout', function(){
      $("svg").find(".vision-tooltip").css('opacity', '0');
    });

    $("svg").find("#finances .planning-cls3").on('mouseover', function(){
      $("svg").find(".finances-tooltip").css('opacity', '1');
    });

    $("svg").find("#finances .planning-cls3").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".finances-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#finances .planning-cls3").on('mouseout', function(){
      $("svg").find(".finances-tooltip").css('opacity', '0');
    });

    $("svg").find("#finances image").on('mouseover', function(){
      $("svg").find(".finances-tooltip").css('opacity', '1');
    });

    $("svg").find("#finances image").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".finances-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#finances image").on('mouseout', function(){
      $("svg").find(".finances-tooltip").css('opacity', '0');
    });

    $("svg").find("#comm .planning-cls3").on('mouseover', function(){
      $("svg").find(".comm-tooltip").css('opacity', '1');
    });

    $("svg").find("#comm .planning-cls3").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".comm-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#comm .planning-cls3").on('mouseout', function(){
      $("svg").find(".comm-tooltip").css('opacity', '0');
    });

    $("svg").find("#comm image").on('mouseover', function(){
      $("svg").find(".comm-tooltip").css('opacity', '1');
    });

    $("svg").find("#comm image").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".comm-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#comm image").on('mouseout', function(){
      $("svg").find(".comm-tooltip").css('opacity', '0');
    });
  }

  function applyNeedsHoverStates() {
    $("svg").find("#needs .needs-cls-3").on('mouseover', function(){
      $("svg").find(".needs-assess-tooltip").css('opacity', '1');
    });

    $("svg").find("#needs .needs-cls-3").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".needs-assess-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#needs .needs-cls-3").on('mouseout', function(){
      $("svg").find(".needs-assess-tooltip").css('opacity', '0');
    });

    $("svg").find("#needs image").on('mouseover', function(){
      $("svg").find(".needs-assess-tooltip").css('opacity', '1');
    });

    $("svg").find("#needs image").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".needs-assess-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#needs image").on('mouseout', function(){
      $("svg").find(".needs-assess-tooltip").css('opacity', '0');
    });
  }

  function applyContImprovHoverStates() {
    $("svg").find("#contimprov .improv-cls-3").on('mouseover', function(){
      $("svg").find(".improv-tooltip").css('opacity', '1');
    });

    $("svg").find("#contimprov .improv-cls-3").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".improv-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#contimprov .improv-cls-3").on('mouseout', function(){
      $("svg").find(".improv-tooltip").css('opacity', '0');
    });

    $("svg").find("#contimprov image").on('mouseover', function(){
      $("svg").find(".improv-tooltip").css('opacity', '1');
    });

    $("svg").find("#contimprov image").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".improv-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#contimprov image").on('mouseout', function(){
      $("svg").find(".improv-tooltip").css('opacity', '0');
    });

  }
  function applyProgrammingHoverStates() {
    $("svg").find("#programming .implementation-cls-4").on('mouseover', function(){
      $("svg").find(".programming-tooltip").css('opacity', '1');
    });

    $("svg").find("#programming .implementation-cls-4").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".programming-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#programming .implementation-cls-4").on('mouseout', function(){
      $("svg").find(".programming-tooltip").css('opacity', '0');
    });

    $("svg").find("#programming image").on('mouseover', function(){
      $("svg").find(".programming-tooltip").css('opacity', '1');
    });

    $("svg").find("#programming image").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".programming-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#programming image").on('mouseout', function(){
      $("svg").find(".programming-tooltip").css('opacity', '0');
    });

    $("svg").find("#integrate .implementation-cls-4").on('mouseover', function(){
      $("svg").find(".integrate-tooltip").css('opacity', '1');
    });

    $("svg").find("#integrate .implementation-cls-4").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".integrate-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#integrate .implementation-cls-4").on('mouseout', function(){
      $("svg").find(".integrate-tooltip").css('opacity', '0');
    });

    $("svg").find("#integrate image").on('mouseover', function(){
      $("svg").find(".integrate-tooltip").css('opacity', '1');
    });

    $("svg").find("#integrate image").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".integrate-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#integrate image").on('mouseout', function(){
      $("svg").find(".integrate-tooltip").css('opacity', '0');
    });

    $("svg").find("#standards .implementation-cls-4").on('mouseover', function(){
      $("svg").find(".standards-tooltip").css('opacity', '1');
    });

    $("svg").find("#standards .implementation-cls-4").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".standards-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#standards .implementation-cls-4").on('mouseout', function(){
      $("svg").find(".standards-tooltip").css('opacity', '0');
    });

    $("svg").find("#standards image").on('mouseover', function(){
      $("svg").find(".standards-tooltip").css('opacity', '1');
    });

    $("svg").find("#standards image").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".standards-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#standards image").on('mouseout', function(){
      $("svg").find(".standards-tooltip").css('opacity', '0');
    });

    $("svg").find("#prof-dev .implementation-cls-4").on('mouseover', function(){
      $("svg").find(".prof-dev-tooltip").css('opacity', '1');
    });

    $("svg").find("#prof-dev .implementation-cls-4").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".prof-dev-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#prof-dev .implementation-cls-4").on('mouseout', function(){
      $("svg").find(".prof-dev-tooltip").css('opacity', '0');
    });

    $("svg").find("#prof-dev image").on('mouseover', function(){
      $("svg").find(".prof-dev-tooltip").css('opacity', '1');
    });

    $("svg").find("#prof-dev image").on('click', function(e){
      $("svg").find(".tooltip").css('opacity', '0');
      $("svg").find(".prof-dev-tooltip").css('opacity', '1');
      e.stopPropagation();
    });

    $("svg").find("#prof-dev image").on('mouseout', function(){
      $("svg").find(".prof-dev-tooltip").css('opacity', '0');
    });
  }

});
